module.exports = __webpack_public_path__ + "officialStatic/img/solution-value-three1.7e71185.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/solution/solution-value-three1.png
// module id = vEQx
// module chunks = 0